import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import React, {useEffect, useState} from "react";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import StateViewController from "../../vc/StateViewController";
import {getManager} from "../../../ts/manager/Manager";
import {PostType} from "../../../ts/manager/post/PostManager";
import DataModel from "../../../ts/model-factory/basic/data/DataModel";
import {PostListRouteModel} from "../../../ts/route/subject/PostListRouteFactory";
import {
    PostActivityDataChoice,
    SourceActivityType
} from "../../../ts/data/subject/PostActivityDataFactory";
import AppButton from "../../element/button/AppButton";
import {JSX} from "react/jsx-runtime";
import {IRouteChoices} from "../../../ts/model-factory/basic/route/RouteChoice";
import {IPostDataChoices} from "../../../ts/data/subject/PostDataFactory";
import {IAnyObject} from "../../../ts/common/SimpleInterface";
import moment from "moment";
import {phpToMomentDateFormat} from "../../../ts/common/SiteHelper";
import eventBus from "../../../ts/event/EventBus";
import HTMLContentView from "../../partial/content-blocks/HTMLContentView";

const ActivityPage = (props:IRouteProps) =>
{
    const organisationID = getManager().user.organisationID;
    const postActivityDataModel = getModelFactory().postActivityData.postActivityDataModel(organisationID);
    const postTypes:PostType[] = [];
    let choiceList = postActivityDataModel.choiceList().slice();

    const dataModels: DataModel|(DataModel|null)[] = [postActivityDataModel];
    const [showActivityTypeDropdown, setShowActivityTypeDropdown] = useState<boolean>(false);
    const [showActivityPostTypeDropdown, setShowActivityPostTypeDropdown] = useState<boolean>(false);
    const [showActivityPostIdDropdown, setShowActivityPostIdDropdown] = useState<boolean>(false);
    const [, setSimpleState] = useState<any[]>([]);

    const postListRouteModels:{
        [key: string]: PostListRouteModel;
    } = {};


    const postTypeOrder:PostType[] = ["project", "offer", "organisation"];

    for(let i= 0; i<choiceList.length; i++){
        const choice = choiceList[i];
        if(!choice.subjectPostType || !postTypeOrder.includes(choice.subjectPostType)){
            choiceList.splice(i,1);
            i --;
            continue;
        }
        if(choice.subjectPostType && !postTypes.includes(choice.subjectPostType)){
            postTypes.push(choice.subjectPostType);
        }
    }
    const allPostTypes = postTypes.slice();
    if(!allPostTypes.includes("organisation")){
        allPostTypes.push("organisation");
    }
    const routeChoices:IRouteChoices = {};
    const postDataChoices:IPostDataChoices = {};
    for(let postType of allPostTypes){

        const postTypeListRouteModel = getModelFactory().postListRoute.getDefaultModel(postType);
        if(postTypeListRouteModel){
            const dataModel = postTypeListRouteModel?.postDataModel ?? null;
            if(dataModel){
                postListRouteModels[postType] = postTypeListRouteModel;
                dataModels.push(dataModel)
                for(let routeChoice of postTypeListRouteModel.choiceList()){
                    routeChoices[routeChoice.id] = routeChoice;
                }
            }
            const myEditDataModel = getModelFactory().postData.getPostDataModel(postType, true)
            dataModels.push(myEditDataModel)
            const sharedDataModel = getModelFactory().postData.getSharedDataModel(postType)
            for(let choice of sharedDataModel.choiceList()){
                postDataChoices[choice.id] = choice;
            }
        }
    }

    useEffect(() =>
    {

        const onBaseClick = (event: CustomEvent) => {
            const htmlElement:HTMLElement|null = event.detail.htmlElement ?? null;
            const dropdownButton:HTMLButtonElement|null = (htmlElement?.closest(".dropdown")?.getElementsByTagName("button") ?? [])[0] ?? null;
            const buttonID = dropdownButton?.id ?? null;
            if(showActivityTypeDropdown && (buttonID !== "filterTypeDropdown")){
                setShowActivityTypeDropdown(false);
            } else if(showActivityPostTypeDropdown && (buttonID !== "filterPostTypeDropdown")){
                setShowActivityPostTypeDropdown(false);
            } else if(showActivityPostIdDropdown && (buttonID !== "filterPostIdDropdown")){
                setShowActivityPostIdDropdown(false);
            }
        }


        eventBus.on("site.base-click", onBaseClick);

        return () =>
        {
            eventBus.remove("site.base-click", onBaseClick);
        };
    }, [showActivityTypeDropdown, showActivityPostTypeDropdown, showActivityPostIdDropdown]);

    const viewState = StateViewController({
        routeProps: props,
        dataModels: dataModels
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    const getLastestActivity = () => {
        postActivityDataModel.resetPopulated();
        postActivityDataModel.requirePopulated().then()
        setSimpleState([]);
    }


    const allActivityChoiceLists:{
        [key: string]: {
            [key: string]: PostActivityDataChoice[][];
        }
    } = {};


    const activityTypeNames:{
        [key in SourceActivityType]: string
    } = {
        "my-organisation": "My Organisation",
        "requests": "Requests",
    }
    const activityTypeOrder:SourceActivityType[] = []

    const knownParams = getManager().navigation.model.knownParams;
    let currentActivityType:SourceActivityType|"" = (knownParams.activity_type ?? "") as SourceActivityType|"";
    let currentActivityPostType:PostType|"" = (knownParams.activity_post_type ?? "") as PostType|"";
    let currentActivityPostID = parseInt(knownParams.activity_post_id ?? "0");


    for(let i = 0; i < choiceList.length; i ++){
        const choice = choiceList[i];
        choice.clientBody = getModelFactory().postActivityData.getClientBody(choice, routeChoices, postDataChoices) ?? "";
        if(!choice.clientBody){
            choiceList.splice(i, 1);
            i --;
        }
        choice.clientTitle = getModelFactory().postActivityData.getClientTitle(choice) ?? "";
    }
    for(let choice of choiceList){
        const postType = choice.subjectPostType as PostType;
        const activityType = choice.sourceActivityType;


        if(!allActivityChoiceLists[activityType]){
            allActivityChoiceLists[activityType] = {};
        }
        if(!allActivityChoiceLists[activityType][postType]){
            allActivityChoiceLists[activityType][postType] = [];
        }
        let found = false;
        for(let thisActivityChoiceList of allActivityChoiceLists[activityType][postType]){
            const primaryActivityChoice = thisActivityChoiceList[0];
            if(primaryActivityChoice?.subjectPostID === choice.subjectPostID){
                thisActivityChoiceList.push(choice)
                found = true;
                break;
            }
        }
        if(!found){
            allActivityChoiceLists[activityType][postType].push([choice]);
        }
        if(!activityTypeOrder.includes(activityType)){
            activityTypeOrder.push(activityType);
        }
    }
    if(Object.keys(allActivityChoiceLists).length === 1){
        currentActivityType = Object.keys(allActivityChoiceLists)[0] as SourceActivityType
    }
    if(!currentActivityType || !allActivityChoiceLists[currentActivityType]){
        currentActivityType = "";
        currentActivityPostType = "";
        currentActivityPostID = 0;
    } else {
        const fromPostTypes = allActivityChoiceLists[currentActivityType];
        if(Object.keys(fromPostTypes).length === 1){
            currentActivityPostType = Object.keys(fromPostTypes)[0] as PostType;
        }
        if(!currentActivityPostType || !fromPostTypes[currentActivityPostType]){
            currentActivityPostType = "";
            currentActivityPostID = 0;
        } else {
            const fromChoiceList = fromPostTypes[currentActivityPostType];
            if(fromChoiceList.length === 1){
                const primaryActivityChoice = fromChoiceList[0][0];
                currentActivityPostID = primaryActivityChoice?.subjectPostID ?? 0;
            }
            if(currentActivityPostID){
                let found = false;
                for(let thisActivityChoiceList of fromChoiceList){
                    const primaryActivityChoice = thisActivityChoiceList[0];
                    if(primaryActivityChoice?.subjectPostID === currentActivityPostID){
                        found = true;
                        break;
                    }
                }
                if(!found){
                    currentActivityPostID = 0;
                }
            }
        }
    }

    const onDropdownSelected= () => {
        setSimpleState([]);
        setShowActivityTypeDropdown(false)
        setShowActivityPostTypeDropdown(false)
        setShowActivityPostIdDropdown(false)
    }

    const getActivityTypeHref = (activityType:SourceActivityType|"" = "") => {
        const params:IAnyObject = {}
        params.activity_type = activityType;
        return getManager().navigation.model.constructQueryHref(params);
    }

    const getPostTypeHref = (postType:PostType|"" = "") => {
        const params:IAnyObject = {}
        if(Object.keys(allActivityChoiceLists).length !== 1){
            params.activity_type = currentActivityType;
        }
        params.activity_post_type = postType;
        return getManager().navigation.model.constructQueryHref(params);
    }

    const getPostIDHref = (postID:number = 0) => {
        const params:IAnyObject = {}
        if(Object.keys(allActivityChoiceLists).length !== 1){
            params.activity_type = currentActivityType;
        }
        const fromPostTypes = currentActivityType ? (allActivityChoiceLists[currentActivityType] ?? {}) : {};
        if(Object.keys(fromPostTypes).length !== 1){
            params.activity_post_type = currentActivityPostType;
        }
        params.activity_post_id = postID;
        return getManager().navigation.model.constructQueryHref(params);
    }

    const postTypeName = (postType:PostType) => {
        const config = getManager().post.config[postType];
        return postType === "organisation" ? config.name : config.plural;
    }

    return <>
        <section className="content-block">
            <div className="container">
                <div className="row">
                    <div className="col">
                        {activityTypeOrder.length > 1 && <>

                            <div className="float-start me-2">
                                <label htmlFor="filterTypeDropdown" className="filter-label visually-hidden">
                                    All Types
                                </label>
                                <div className="dropdown">
                                    <AppButton
                                        className={"btn btn-secondary dropdown-toggle " + (showActivityTypeDropdown ? "show" : "")}
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        id="filterTypeDropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded={showActivityTypeDropdown ? "true" : "false"}
                                        onClick={() =>{
                                            setShowActivityTypeDropdown(!showActivityTypeDropdown)
                                            setShowActivityPostTypeDropdown(false)
                                            setShowActivityPostIdDropdown(false)
                                        }}
                                    >
                                        {!currentActivityType ? "All Types" : activityTypeNames[currentActivityType]}
                                    </AppButton>
                                    <div
                                        className={"dropdown-menu stay-on-page-dropdown-menu " + (showActivityTypeDropdown ? "show" : "")}
                                        aria-labelledby="filterTypeDropdown">
                                        <AppButton
                                            className="dropdown-item"
                                            href={getActivityTypeHref()}
                                            onClick={() => onDropdownSelected()}
                                        >
                                            View All
                                        </AppButton>

                                        {activityTypeOrder.map((activityType, index) =>
                                        {
                                            return <AppButton
                                                key={index}
                                                className="dropdown-item"
                                                href={getActivityTypeHref(activityType)}
                                                onClick={() => onDropdownSelected()}
                                            >
                                                {activityTypeNames[activityType]}
                                            </AppButton>
                                        })}

                                    </div>
                                </div>
                            </div>
                        </>}
                        {!!currentActivityType && !!allActivityChoiceLists[currentActivityType] && Object.keys(allActivityChoiceLists[currentActivityType]).length > 1 && <>

                            <div className="float-start me-2">
                                <label htmlFor="filterPostTypeDropdown" className="filter-label visually-hidden">
                                    All Post Types
                                </label>
                                <div className="dropdown">
                                    <AppButton
                                        className={"btn btn-secondary dropdown-toggle " + (showActivityPostTypeDropdown ? "show" : "")}
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        id="filterPostTypeDropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded={showActivityPostTypeDropdown ? "true" : "false"}
                                        onClick={() =>{
                                            setShowActivityTypeDropdown(false)
                                            setShowActivityPostTypeDropdown(!showActivityPostTypeDropdown)
                                            setShowActivityPostIdDropdown(false)
                                        }}
                                    >
                                        {!currentActivityPostType ? "All Post Types" : currentActivityPostType ? postTypeName(currentActivityPostType) : ""}
                                    </AppButton>
                                    <div
                                        className={"dropdown-menu stay-on-page-dropdown-menu " + (showActivityPostTypeDropdown ? "show" : "")}
                                        aria-labelledby="filterPostTypeDropdown">
                                        <AppButton
                                            className="dropdown-item"
                                            href={getPostTypeHref()}
                                            onClick={() => onDropdownSelected()}
                                        >
                                            View All
                                        </AppButton>

                                        {postTypeOrder.map((postType, index) =>
                                        {
                                            if(!currentActivityType || !allActivityChoiceLists[currentActivityType] || !allActivityChoiceLists[currentActivityType][postType]){
                                                return "";
                                            }
                                            return <AppButton
                                                key={index}
                                                className="dropdown-item"
                                                href={getPostTypeHref(postType)}
                                                onClick={() => onDropdownSelected()}
                                            >
                                                {postTypeName(postType)}
                                            </AppButton>
                                        })}

                                    </div>
                                </div>
                            </div>
                        </>}
                        {!!currentActivityType && !!currentActivityPostType && !!allActivityChoiceLists[currentActivityType] && !!allActivityChoiceLists[currentActivityType][currentActivityPostType] && Object.keys(allActivityChoiceLists[currentActivityType][currentActivityPostType]).length > 1 && <>
                            <div className="float-start me-2">
                                <label htmlFor="filterPostIdDropdown" className="filter-label visually-hidden">
                                    All {currentActivityPostType ? postTypeName(currentActivityPostType) : ""}
                                </label>
                                <div className="dropdown">
                                    <AppButton
                                        className={"btn btn-secondary dropdown-toggle " + (showActivityPostIdDropdown ? "show" : "")}
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        id="filterPostIdDropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded={showActivityPostIdDropdown ? "true" : "false"}
                                        onClick={() =>{
                                            setShowActivityTypeDropdown(false)
                                            setShowActivityPostTypeDropdown(false)
                                            setShowActivityPostIdDropdown(!showActivityPostIdDropdown)
                                        }}
                                    >
                                        {!currentActivityPostID ? "All "+(currentActivityPostType ? postTypeName(currentActivityPostType) : "") : (routeChoices[currentActivityPostID] ? routeChoices[currentActivityPostID].name : "")}
                                    </AppButton>
                                    <div
                                        className={"dropdown-menu stay-on-page-dropdown-menu " + (showActivityPostIdDropdown ? "show" : "")}
                                        aria-labelledby="filterPostIdDropdown">
                                        <AppButton
                                            className="dropdown-item"
                                            href={getPostIDHref()}
                                            onClick={() => onDropdownSelected()}
                                        >
                                            View All
                                        </AppButton>

                                        {(() =>
                                        {
                                            const rendered: JSX.Element[] = [];
                                            let index = -1;
                                            const fromChoiceList = currentActivityType && currentActivityPostType && allActivityChoiceLists[currentActivityType] ? (allActivityChoiceLists[currentActivityType][currentActivityPostType] ?? []) : [];
                                            for(let fromChoice of fromChoiceList){
                                                index ++
                                                const primaryActivityChoice = fromChoice[0];
                                                rendered.push(<AppButton
                                                    key={index}
                                                    className="dropdown-item"
                                                    href={getPostIDHref(primaryActivityChoice?.subjectPostID ?? 0)}
                                                    onClick={() => onDropdownSelected()}
                                                >
                                                    {primaryActivityChoice?.subjectPostTitle ?? ""}
                                                </AppButton>)
                                            }
                                            return rendered;
                                        })()}

                                    </div>
                                </div>
                            </div>
                        </>}

                    </div>
                </div>
            </div>
        </section>
        {!!activityTypeOrder.length ? <>

            {activityTypeOrder.map((activityType, index) =>
            {
                if(currentActivityType && (activityType !== currentActivityType)){
                    return "";
                }
                const activityTypeChoiceLists = allActivityChoiceLists[activityType] ??  {};
                if(!activityTypeChoiceLists){
                    return "";
                }
                const rendered: JSX.Element[] = [];
                if(activityTypeOrder.length > 1){
                    rendered.push(<section key={index+"_title"} className="content-block py-0">
                        <div className="container">

                            <div className="row">
                                <div className="col-12">
                                    <strong>{activityTypeNames[activityType]}</strong>
                                </div>
                            </div>
                        </div>
                    </section>)
                }
                let postTypeIndex = -1;
                for(let postType of postTypeOrder){
                    if(currentActivityPostType && (postType !== currentActivityPostType)){
                        continue;
                    }

                    const postTypeChoiceList = activityTypeChoiceLists[postType] ?? [];
                    if(!postTypeChoiceList.length){
                        continue;
                    }
                    postTypeIndex ++;
                    rendered.push(
                        <section
                            key={index+"_post_types_"+postTypeIndex}
                            className="content-block"
                        >
                            <div className="container">
                                <div className="row">
                                    <div className="col">

                                        <h2 className="block-title bm-5">{postTypeName(postType)} Activity</h2>
                                    </div>
                                </div>

                                {postTypeChoiceList.map((thisActivityChoiceList, index) =>
                                {
                                    const primaryActivityChoice = thisActivityChoiceList[0];
                                    if(!primaryActivityChoice.subjectPostType || !primaryActivityChoice.subjectPostID){
                                        return "";
                                    }
                                    if(currentActivityPostID && (primaryActivityChoice.subjectPostID !== currentActivityPostID)){
                                        return "";
                                    }

                                    return <div key={index} className="activity-group">
                                        <h3 className="mb-5">{primaryActivityChoice.subjectPostTitle}</h3>
                                        <div className="row d-flex row-cols-1 row-cols-md-2 row-cols-lg-3 g-5">

                                            {thisActivityChoiceList.map((activityChoice, index) =>
                                            {

                                                return <div className="col" key={index}>
                                                    <div className="activity-box">
                                                        <h3>{moment(activityChoice.createdDate).format(phpToMomentDateFormat('j M Y'))} @ {moment(activityChoice.createdDate).format(phpToMomentDateFormat('g:ia'))}</h3>

                                                        <div className="wysiwyg-content">
                                                            {!!activityChoice.clientTitle && <>
                                                                <h4>{activityChoice.clientTitle}</h4>
                                                            </>}
                                                            {!!activityChoice.clientBody && <>
                                                                <HTMLContentView
                                                                    className="wysiwyg-content"
                                                                    dangerouslySetInnerHTML={{__html: "<p>" + activityChoice.clientBody + "</p>"}}>
                                                                </HTMLContentView>
                                                            </>}
                                                        </div>
                                                        {!!activityChoice.furtherInformation && <>
                                                            <div className="wysiwyg-content">
                                                                <h4 className="mt-4 mb-2">Further information</h4>
                                                                <HTMLContentView
                                                                    className="wysiwyg-content"
                                                                    dangerouslySetInnerHTML={{__html: activityChoice.getParagraphFurtherInformation()}}>
                                                                </HTMLContentView>
                                                            </div>
                                                        </>}
                                                    </div>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                })}
                            </div>
                        </section>
                    )
                }
                return rendered
            })}
        </>: <>
            <section className="content-block">
                <div className="container">

                    <div className="row">
                        <div className="col">

                            <p>There has been no activity yet with your organisation</p>
                        </div>
                    </div>
                </div>
            </section>
        </>}
    </>
}

export default ActivityPage;